import React from 'react';
import ResidentialMarketList from './components/ResidentialMarket/ResidentialMarketList';
import ApplicationForm from './components/Application/ApplicationForm';
import ApplicationFormSpecialCallForApplication from './components/Application/ApplicationFormSpecialCallForApplication';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from 'react-router-dom';

const routes = (
  <Router>
    <Switch>
			<Route path="/wohnen/wohnungsmarkt/wohnungsbewerbung" component={ApplicationForm}/>
			<Route path="/wohnen/wohnungsmarkt/wohnungsbewerbung/edit/*" component={ApplicationForm}/>
			<Route path="/wohnen/wohnungsmarkt/wohnungsbewerbung-*" component={ApplicationFormSpecialCallForApplication}/>
			<Route path="*" component={ResidentialMarketList}/>
		</Switch>
	</Router>
)

export default routes;
